module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc18-501b9985cdfff15781a35e463a4c906e.jpg";